<nav class="sidenav">
  <!-- Nconnect Voice -->
  <sidenav-item
    (itemClicked)="sideNavItemClicked(true)"
    [itemRouterLinkActiveOptions]="{ exact: false }"
    data-e2e="admin-navigator-fragment__nconnect-voice--a"
    [hasSubItems]="true"
    [itemRouterLink]="['nconnect-voice']"
    [itemTitle]="
      'admin.navigation.nconnect.title' | translate: nconnectVoiceProductName
    "
  >
    <!-- Trunkset -->
    <sidenav-item
      *ngIf="isNconnectPageActive"
      (itemClicked)="sideNavItemClicked(false)"
      data-e2e="admin-navigator-fragment__trunkset--a"
      [hasSubItems]="true"
      [itemRouterLink]="['nconnect-voice', 'trunkset']"
      itemLevel="2"
      [itemTitle]="'admin.navigation.nconnect.trunkset.title' | translate"
    >
      <!-- Blacklist -->
      <sidenav-item
        *ngIf="isBlacklistItemShown"
        (itemClicked)="sideNavItemClicked(true)"
        [itemRouterLinkActiveOptions]="{ exact: false }"
        data-e2e="admin-navigator-fragment__blacklist--a"
        [itemRouterLink]="['nconnect-voice', 'blacklist']"
        [itemTitle]="'admin.navigation.nconnect.blacklist.title' | translate"
      >
        <!-- Blacklist Entry -->
        <sidenav-item
          *ngIf="isBlacklistEntryItemShown"
          (itemClicked)="sideNavItemClicked(false)"
          [itemRouterLinkActiveOptions]="{ exact: false }"
          [itemRouterLink]="['nconnect-voice', 'blacklist', routeParamId]"
          [itemTitle]="nconnectItemName$ | async"
          itemLevel="4"
        >
        </sidenav-item>
      </sidenav-item>
    </sidenav-item>

    <!-- PBX Endpoint -->
    <sidenav-item
      *ngIf="isNconnectPageActive"
      (itemClicked)="sideNavItemClicked(true)"
      [itemRouterLinkActiveOptions]="{ exact: false }"
      [itemRouterLink]="[
        'nconnect-voice',
        'pbx-endpoint',
        firstTrunksetId$ | async,
      ]"
      data-e2e="admin-navigator-fragment__pbx-endpoint--a"
      [hasSubItems]="true"
      itemLevel="2"
      [itemTitle]="'admin.navigation.nconnect.pbx_endpoint.title' | translate"
      appHoverbox
    >
      <hoverbox
        *ngIf="!(pbxEndpointMenuItems$ | async)?.length"
        [showAlways]="true"
      >
        {{ "admin.nconnect.trunkset.table.no_data" | translate }}
      </hoverbox>

      <!-- PBX Endpoint Trunkset Items -->
      <ng-container
        *ngFor="let pbxEndpointItem of pbxEndpointMenuItems$ | async"
      >
        <sidenav-item
          *ngIf="isPbxEndpointItemShown"
          (itemClicked)="sideNavItemClicked(false)"
          [itemRouterLink]="[
            'nconnect-voice',
            'pbx-endpoint',
            pbxEndpointItem.ID,
          ]"
          [itemTitle]="pbxEndpointItem.NAME"
        ></sidenav-item>
      </ng-container>
    </sidenav-item>

    <!-- Number Routing -->
    <sidenav-item
      *ngIf="isNconnectPageActive"
      (itemClicked)="sideNavItemClicked(true)"
      data-e2e="admin-navigator-fragment__number-routing--a"
      [hasSubItems]="true"
      itemLevel="2"
      [itemRouterLink]="['nconnect-voice', 'number-routing']"
      [itemTitle]="'admin.navigation.nconnect.number_routing.title' | translate"
    >
      <!-- Numberblock -->
      <sidenav-item
        *ngIf="isNumberRoutingItemsShown"
        (itemClicked)="sideNavItemClicked(true)"
        [itemRouterLinkActiveOptions]="{ exact: false }"
        data-e2e="admin-navigator-fragment__number-block--a"
        [hasSubItems]="true"
        [itemRouterLink]="['nconnect-voice', 'numberblock']"
        [itemTitle]="'admin.navigation.nconnect.numberblock.title' | translate"
      >
        <!-- Numberblock Entry -->
        <sidenav-item
          *ngIf="isNumberblockEntryItemShown"
          (itemClicked)="sideNavItemClicked(false)"
          [itemRouterLinkActiveOptions]="{ exact: false }"
          [itemRouterLink]="['nconnect-voice', 'numberblock', routeParamId]"
          [itemTitle]="nconnectItemName$ | async"
        >
        </sidenav-item>
      </sidenav-item>

      <!-- Backup numbers -->
      <sidenav-item
        *ngIf="isNumberRoutingItemsShown"
        (itemClicked)="sideNavItemClicked(false)"
        [itemRouterLinkActiveOptions]="{ exact: false }"
        data-e2e="admin-navigator-fragment__backup-numbers--a"
        [itemRouterLink]="['nconnect-voice', 'backupnumbers']"
        [itemTitle]="
          'admin.navigation.nconnect.backup_number.title' | translate
        "
      ></sidenav-item>
    </sidenav-item>

    <!-- Template -->
    <sidenav-item
      *ngIf="isNconnectPageActive"
      (itemClicked)="sideNavItemClicked(true)"
      [itemRouterLinkActiveOptions]="{ exact: false }"
      data-e2e="admin-navigator-fragment__pbx-endpoint-template--a"
      [hasSubItems]="true"
      itemLevel="2"
      [itemRouterLink]="['nconnect-voice', 'pbx-endpoint-template']"
      [itemTitle]="'admin.navigation.nconnect.template.title' | translate"
    >
      <!-- PBX Endpoint Template -->
      <sidenav-item
        *ngIf="isTemplateItemShown"
        (itemClicked)="sideNavItemClicked(false)"
        [itemRouterLinkActiveOptions]="{ exact: false }"
        [itemRouterLink]="['nconnect-voice', 'pbx-endpoint-template']"
        [itemTitle]="
          'admin.navigation.nconnect.template.pbx_endpoint_template' | translate
        "
      ></sidenav-item>
    </sidenav-item>

    <!-- Nconnect services -->
    <sidenav-item
      *ngIf="
        isNconnectPageActive &&
        ((hasConferenceServices$ | async) || (hasFaxServices$ | async))
      "
      (itemClicked)="sideNavItemClicked(true)"
      [itemRouterLinkActiveOptions]="{ exact: false }"
      itemLevel="2"
      [itemRouterLink]="['nconnect-voice', 'services']"
      [itemTitle]="'admin.navigation.nconnect.services.title' | translate"
    >
      <ng-container *ngIf="isServiceItemShown">
        <!-- Conference -->
        <sidenav-item
          *ngIf="hasConferenceServices$ | async"
          (itemClicked)="sideNavItemClicked(false)"
          [itemRouterLinkActiveOptions]="{ exact: false }"
          itemLevel="3"
          [itemRouterLink]="['nconnect-voice', 'services', 'conference']"
          [itemTitle]="
            'admin.navigation.nconnect.services.conference' | translate
          "
        ></sidenav-item>

        <!-- Fax -->
        <sidenav-item
          *ngIf="hasFaxServices$ | async"
          (itemClicked)="sideNavItemClicked(false)"
          [itemRouterLinkActiveOptions]="{ exact: false }"
          itemLevel="3"
          [itemRouterLink]="['nconnect-voice', 'services', 'fax']"
          [itemTitle]="'admin.navigation.nconnect.services.fax' | translate"
        ></sidenav-item>
      </ng-container>
    </sidenav-item>
  </sidenav-item>
</nav>

<logo
  class="sidenav__footer"
  [hasLink]="false"
  location="sidenav__footer"
  (dblclick)="showAppInfo()"
></logo>
